import TotalApplications from "../Administration/TotalApplications";

const TrafficTotalApplications = ({ role }) => {
  return (
    <>
      <TotalApplications role={role} />
    </>
  );
};

export default TrafficTotalApplications;
